import { Component, effect, signal, ChangeDetectionStrategy } from '@angular/core';
import { TextInput } from '../../../shared/components/form-fields/text-input/text-input';
import { Button } from '../../../shared/components/ui/buttons/gradient-btn/button';
import { FormControl, Validators } from '@angular/forms';
import { AppService } from '../../services/app.service';
import { UserService } from '../../services/user.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ForgotPassword } from '../forgot-password/forgot-password';

@Component({
  selector: 'andor-simple-login',
  standalone: true,
  imports: [TextInput, Button, TranslatePipe, ForgotPassword],
  templateUrl: './simple-login.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './simple-login.scss',
})
export class SimpleLogin {
  role = signal<string>('Guest');
  password = new FormControl('', [Validators.required, Validators.minLength(6)]);
  constructor(
    public appService: AppService,
    public userService: UserService
  ) {
    effect(() => {
      const role = this.userService.ownUser()?.data.role;
      if (role) this.role.set(role);
    });
  }
}
